import React from 'react';
import { LazyImg } from 'src/hooks/useLazyLoad';

import classes from './Cards.scss';

const cards = [
    { type: 'master-card', src: require(`../../../static/img/card-mastercard.png`), alt: 'MasterCard' },
    { type: 'visa', src: require(`../../../static/img/card-visa.png`), alt: 'Visa' },
    {
        type: 'american-express',
        src: require(`../../../static/img/card-american-express.png`),
        alt: 'American Express',
    },
    {
        type: 'paypal',
        src: require(`../../../static/img/card-paypal.png`),
        alt: 'Paypal',
    },
    {
        type: 'apple-pay',
        src: require(`../../../static/icons/applepayicon.png`),
        alt: 'Apple Pay',
    },
];

type Props = {
    activeTypes?: string[];
    showPaypal?: boolean;
    className?: string;
};

export const Cards: React.FC<Props> = ({ activeTypes, showPaypal, className }) => {
    return (
        <ul className={className ? `${classes.root} ${className}` : classes.root}>
            {cards.map((card) => {
                const isActive = activeTypes && (activeTypes.length === 0 || activeTypes.indexOf(card.type) > -1);
                return card.type !== 'paypal' || showPaypal ? (
                    <li key={card.alt} className={classes.item} data-active={String(isActive)}>
                        <LazyImg src={card.src} alt={card.alt} />
                    </li>
                ) : null;
            })}
        </ul>
    );
};
